import React from 'react';
import './Rules.css';

const SCHEDULE = [
  { time: 'May 16, 2026', event: '🎣 Derby opens - catches can be submitted' },
  { time: 'May 16 - Aug 18', event: 'Catch submissions and leaderboard updates' },
  { time: 'August 18, 2026', event: '🚫 Derby closes at end of day' },
  { time: 'August 20, 2026', event: '🏆 Final results and category winners announced' },
];

const RULES = [
  {
    heading: 'Eligibility',
    items: [
      'Open to all employees.',
      'Participants can register at any point during the event.',
    ],
  },
  {
    heading: 'Equipment',
    items: [
      'Artificial lures and live bait are both permitted.',
      'Each angler may use one rod and one line at a time.',
      'No nets, traps, or non-sporting methods.',
    ],
  },
  {
    heading: 'Catch & Scoring',
    items: [
      'This season has four categories: Most Unique Catch, Smallest Cutest Catch, Largest Fish by Length, and Most Species Caught.',
      'Each catch submission must include a photo, species, length, and short description.',
      'Species should be selected from the dropdown list when possible to keep entries consistent.',
      'Fish must be caught within the derby period: May 16 through August 18, 2026.',
      'Judges may request additional details to validate category submissions.',
    ],
  },
  {
    heading: 'Licenses & Regulations',
    items: [
      'All participants 16+ must hold a valid provincial fishing license.',
      'All provincial fishing regulations apply at all times.',
      'Possession and size limits as per provincial rules must be respected.',
    ],
  },
  {
    heading: 'Safety',
    items: [
      'Life jackets must be worn at all times when on watercraft.',
      'All participants act at their own risk. The organizers are not liable for accidents or injuries.',
      'Please respect the environment — pack out what you pack in.',
    ],
  },
  {
    heading: 'Decisions & Disputes',
    items: [
      'All decisions by the derby organizers are final.',
      'Any participant found cheating or breaking rules will be disqualified.',
    ],
  },
];

function Rules() {
  return (
    <div className="page-container">
      <h1 className="page-title">Rules & Schedule</h1>
      <p className="page-subtitle">Please read all rules before registering.</p>

      {/* Schedule */}
      <h2 className="section-heading">Day-of Schedule</h2>
      <div className="card schedule-card">
        <ol className="schedule-list">
          {SCHEDULE.map((item, i) => (
            <li key={i} className="schedule-item">
              <span className="schedule-time">{item.time}</span>
              <span className="schedule-event">{item.event}</span>
            </li>
          ))}
        </ol>
      </div>

      {/* Rules */}
      <h2 className="section-heading">Official Rules</h2>
      {RULES.map((section, i) => (
        <div key={i} className="card rules-card">
          <h3 className="rules-heading">{section.heading}</h3>
          <ul className="rules-list">
            {section.items.map((rule, j) => (
              <li key={j}>{rule}</li>
            ))}
          </ul>
        </div>
      ))}

      <div className="card rules-disclaimer">
        <p>
          Rules are subject to change. Any updates will be communicated via email to
          registered participants. Questions? Email{' '}
          <a href="mailto:jacob.reszitnyk@ontario.ca">jacob.reszitnyk@ontario.ca</a>.
        </p>
      </div>
    </div>
  );
}

export default Rules;
